import domReady from '@wordpress/dom-ready';

domReady( () => {
	const navWrapper = document.querySelectorAll( '.tabs_navigation_wrapper' );
	navWrapper?.forEach( ( nav ) => {
		const parent = nav.closest( '.levit_tabs_block' );
		const tabs = parent.querySelector( '.tabs_list_container' );
		const tabsCount = tabs.children.length;
		const prevButton = nav.querySelector( '.tabs_navigation_prev' );
		const nextButton = nav.querySelector( '.tabs_navigation_next' );
		if ( tabsCount > 0 ) {
			prevButton?.addEventListener( 'click', () => {
				const activeTab = parent.querySelector(
					'.tabs_list_container .active'
				);
				const activeTabIndex = Array.prototype.indexOf.call(
					tabs.children,
					activeTab
				);
				if ( activeTabIndex !== 0 ) {
					tabs.children[ activeTabIndex - 1 ].click();
				} else {
					tabs.children[ tabsCount - 1 ].click();
				}
			} );
			nextButton?.addEventListener( 'click', () => {
				const activeTab = parent.querySelector(
					'.tabs_list_container .active'
				);
				const activeTabIndex = Array.prototype.indexOf.call(
					tabs.children,
					activeTab
				);
				if ( activeTabIndex !== tabsCount - 1 ) {
					tabs.children[ activeTabIndex + 1 ].click();
				} else {
					tabs.children[ 0 ].click();
				}
			} );
		}
	} );

	const allTabs = document.querySelectorAll( '.levit_tabs_block' );
	allTabs?.forEach( ( tab ) => {
		const tabs = tab.querySelector( '.tabs_list_container' );
		const contentContainer = tab.querySelector( '.tabs_content_container' );
		tabs?.children[ 0 ].classList.add( 'active' );
		contentContainer?.children[ 0 ].classList.add( 'active' );

		if (
			contentContainer.children.length > 0 &&
			contentContainer.children.length > 0
		) {
			for ( let i = 0; i < tabs.children.length; i++ ) {
				tabs.children[ i ].addEventListener( 'click', () => {
					Array.from( tabs.children ).forEach( ( tabItem ) => {
						tabItem.classList.remove( 'active' );
					} );
					if ( ! tabs.children[ i ].classList.contains( 'active' ) ) {
						tabs.children[ i ].classList.add( 'active' );
					}

					Array.from( contentContainer.children ).forEach(
						( child ) => {
							child.classList.remove( 'active' );
						}
					);
					if (
						! contentContainer.children[ i ].classList.contains(
							'active'
						)
					) {
						contentContainer.children[ i ].classList.add(
							'active'
						);
					}
				} );
			}
		}
	} );
} );
